import clsx from 'clsx';
import React from 'react';

import {Checkbox} from '../Checkbox';
import {DividerVertical} from '../Divider/Divider';

import type {SelectionData, SelectionHelpers2} from './useSelection';

type Props<T> = React.HtmlHTMLAttributes<HTMLDivElement> & {
  name: string;
  selected: SelectionData;
  helpers: SelectionHelpers2<T>;
  totalCount: number;
  right?: boolean;
  children?: React.ReactNode;
};
export function SelectionControl<T = string>({
  name,
  selected,
  helpers,
  totalCount,
  right,
  className,
  children,
  ...props
}: Props<T>): React.JSX.Element {
  const handleChange: React.ComponentProps<
    typeof Checkbox
  >['onCheckedChange'] = (checked): void => {
    helpers.dispatch({
      type: 'TOGGLE_ALL',
      payload: {checked: checked === true},
    });
  };

  return (
    <div
      {...props}
      className={clsx(
        className,
        'flex min-h-7 items-center gap-2',
        right && 'justify-end'
      )}
    >
      {(selected.all || !!selected.touched.length) && !!children && (
        <>
          {children}
          <DividerVertical />
        </>
      )}

      <Checkbox
        name={name}
        checked={
          helpers.isIndeterminate
            ? 'indeterminate'
            : selected.all || !!selected.touched.length
        }
        onCheckedChange={handleChange}
        label={
          <>
            <b>
              {helpers.getSelectedCount(totalCount)} of {totalCount}
            </b>{' '}
            selected
          </>
        }
      />
    </div>
  );
}

SelectionControl.displayName = 'SelectionControl';
